import { render, staticRenderFns } from "./FormBuilderDetailPage.vue?vue&type=template&id=5e9c1a56&"
import script from "./FormBuilderDetailPage.vue?vue&type=script&lang=ts&"
export * from "./FormBuilderDetailPage.vue?vue&type=script&lang=ts&"
import style0 from "./FormBuilderDetailPage.vue?vue&type=style&index=0&id=5e9c1a56&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports